import { gql } from "@apollo/client";
import { EnforcementIntentDetail, enforcementIntentDetailFragment } from "../fragments";

export const UPDATE_ENFORCEMENT_INTENT_DUE_AT = gql`
  mutation UpdateEnforcementIntentDueAt($id: uuid!, $dueAt: timestamptz!) {
    enforcementIntent: update_enforcement_intent_by_pk(pk_columns: { id: $id }, _set: { due_at: $dueAt }) {
      ...enforcementIntentDetailFragment
    }
  }
  ${enforcementIntentDetailFragment}
`;

export interface UpdateEnforcementIntentDueAtData {
  enforcementIntent: EnforcementIntentDetail;
}

export interface UpdateEnforcementIntentDueAtVars {
  id: string;
  dueAt: Date;
}
